import { Theme } from '../types';

export const darkTheme: Theme = {
  name: 'dark',
  colors: {
    gray: {
      50: '#0f172a',
      100: '#1e293b',
      200: '#334155',
      300: '#475569',
      400: '#64748b',
      500: '#94a3b8',
      600: '#cbd5e1',
      700: '#e2e8f0',
      800: '#f1f5f9',
      900: '#f8fafc',
    },
    accent: {
      50: '#3c366b',
      100: '#434190',
      200: '#4c51bf',
      300: '#5a67d8',
      400: '#667eea',
      500: '#8a9fff',
      600: '#b4c3ff',
      700: '#d4ddff',
      800: '#ebeeff',
      900: '#f5f7ff',
    },
    semantic: {
      success: '#68d391',
      successLight: '#1a2e1a',
      error: '#fc8181',
      errorLight: '#2e1515',
      warning: '#fbb040',
      warningLight: '#2e1f0a',
      info: '#63b3ed',
      infoLight: '#0a1f2e',
    },
    background: {
      app: '#1e293b',
      surface: '#334155',
      elevated: '#475569',
      navbar: '#334155',
      sidebar: '#1e293b',
      hover: '#475569',
      active: '#64748b',
      blueprint: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
    },
    text: {
      primary: '#f8fafc',
      secondary: '#e2e8f0',
      tertiary: '#cbd5e1',
      disabled: '#94a3b8',
      inverse: '#1e293b',
      accent: '#8a9fff',
      onAccent: '#1e293b',
      muted: '#cbd5e1',
    },
    border: {
      color: '#64748b',
      light: '#475569',
      medium: '#94a3b8',
    },
    button: {
      bg: '#475569',
      bgHover: '#64748b',
      bgActive: '#94a3b8',
      text: '#f1f5f9',
      border: '#94a3b8',
      primary: {
        bg: '#8a9fff',
        bgHover: '#667eea',
        bgActive: '#b4c3ff',
        text: '#1e293b',
      },
      disabled: {
        bg: '#475569',
        text: '#94a3b8',
        border: '#64748b',
      },
    },
    input: {
      bg: '#334155',
      border: '#94a3b8',
      borderHover: '#cbd5e1',
      borderFocus: '#8a9fff',
      text: '#f8fafc',
      placeholder: '#94a3b8',
    },
    toggle: {
      bg: '#94a3b8',
      bgActive: '#8a9fff',
      thumb: '#1e293b',
    },
    executing: '#ff6b35',
    focus: '#8a9fff',
    overlay: {
      light: 'rgba(255, 255, 255, 0.05)',
      medium: 'rgba(255, 255, 255, 0.1)',
      heavy: 'rgba(255, 255, 255, 0.15)',
      white: 'rgba(0, 0, 0, 0.1)',
    },
    shadow: {
      medium: 'rgba(0, 0, 0, 0.5)',
    },
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
    // Legacy spacing
    small: '8px',
    medium: '16px',
    large: '24px',
  },
  typography: {
    fontFamily: "'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize: {
      xs: '12px',
      sm: '14px',
      base: '16px',
      lg: '18px',
      xl: '20px',
      xxl: '24px',
      xxxl: '30px',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    text: {
      xs: '12px',
      small: '14px',
      medium: '16px',
    },
  },
  borderRadius: {
    sm: '6px',
    md: '10px',
    lg: '16px',
    full: '9999px',
    // Legacy border radius
    small: '3px',
    medium: '8px',
  },
  shadows: {
    xs: '0 1px 2px 0 rgba(0, 0, 0, 0.3)',
    sm: '0 1px 3px 0 rgba(0, 0, 0, 0.4), 0 1px 2px -1px rgba(0, 0, 0, 0.4)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.4), 0 2px 4px -2px rgba(0, 0, 0, 0.4)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.4), 0 4px 6px -4px rgba(0, 0, 0, 0.4)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.4), 0 8px 10px -6px rgba(0, 0, 0, 0.4)',
  },
  zIndex: {
    dropdown: 100,
    sticky: 200,
    overlay: 500,
    modal: 1000,
    toast: 2000,
    // Legacy z-index
    base: 0,
    accent: 5,
    content: 10,
    floating: 20,
  },
  transitions: {
    fast: '150ms cubic-bezier(0.4, 0, 0.2, 1)',
    base: '200ms cubic-bezier(0.4, 0, 0.2, 1)',
    slow: '300ms cubic-bezier(0.4, 0, 0.2, 1)',
  },
  breakpoints: {
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    xxl: '1536px',
  },
};